import React from "react";
import {HistoryRewardType} from "../../../../type/historyReward";
import HistoryRewardsContent from "./HistoryRewardsContent";
import {Custom} from "../../../../pages/Custom";
import {HttpService} from "../../../../service/HttpService";

export const HistoryRewardsContest = () => {
    const customProject = HttpService?.customProject;
    return (<>
        {
            customProject?.customFrontend && customProject?.frontendComponents?.some(component => component?.pathUrl === "/history-rewards-custom")
                ? (
                    <Custom
                        customFrontendUrl={customProject?.customFrontendUrl}
                        type={customProject?.frontendComponents?.find(comp => comp?.pathUrl === "/history-rewards-custom")?.component}
                    />
                ) :
                <HistoryRewardsContent type={HistoryRewardType.CONTEST} />
        }
        </>
    );
}

export const HistoryRewardsCatalog = () => {
    const customProject = HttpService?.customProject;
    return (<>
        {
            customProject?.customFrontend && customProject?.frontendComponents?.some(component => component?.pathUrl === "/history-rewards-catalog-custom")
                ? (
                    <Custom
                        customFrontendUrl={customProject?.customFrontendUrl}
                        type={customProject?.frontendComponents?.find(comp => comp?.pathUrl === "/history-rewards-catalog-custom")?.component}
                    />
                ) :
                <HistoryRewardsContent type={HistoryRewardType.CATALOG} />
        }
        </>
    )
}

export const HistoryRewardsCatalogLC = () => {
    const customProject = HttpService?.customProject;
    return (<>
        {
            customProject?.customFrontend && customProject?.frontendComponents?.some(component => component?.pathUrl === "/history-rewards-catalog-loyalty-collection-custom")
                ? (
                    <Custom
                        customFrontendUrl={customProject?.customFrontendUrl}
                        type={customProject?.frontendComponents?.find(comp => comp?.pathUrl === "/history-rewards-catalog-loyalty-collection-custom")?.component}
                    />
                ) :
                <HistoryRewardsContent type={HistoryRewardType.CATALOG_LOYALTY_COLLECTION} />
        }
        </>
    );
}

export const HistoryRewardsCatalogDW = () => {
    const customProject = HttpService?.customProject;
    return (<>
        {
            customProject?.customFrontend && customProject?.frontendComponents?.some(component => component?.pathUrl === "/history-rewards-catalog-digital-wallet-custom")
                ? (
                    <Custom
                        customFrontendUrl={customProject?.customFrontendUrl}
                        type={customProject?.frontendComponents?.find(comp => comp?.pathUrl === "/history-rewards-catalog-digital-wallet-custom")?.component}
                    />
                ) :
                <HistoryRewardsContent type={HistoryRewardType.CATALOG_DIGITAL_WALLET} />
        }
        </>
    )
}

